<template>
       <div class="headTitle">
         <h3>{{title}}</h3>
          <button @click="lookMore()">{{$t('common.viewMore')}}</button>
      </div>
  </div>
</template>

<script>
import  configuration  from '../../../../config.js'
export default {

  data() {
    return {
         index:this.tab,
          remoteUrl:configuration.exhibitionList,
    };
  },
  created() {
 
  },
  props:{
      flag:{},
      title:{},
      tab:{},
  },

  methods: {
    //查看更多
    lookMore(){ 
             const number = Number(this.index);
             if ( number== 1) {
                const url = this.remoteUrl + 'exhibition';
                window.open(url, "_blank");
             }else if (number == 2) {
                 const url = this.remoteUrl + 'exhibitsList';
                   window.open(url, "_blank");
             }else if (number == 3) {
             const url = this.remoteUrl + 'live';
               window.open(url, "_blank");
             }else if (number == 4) {
              const url = this.remoteUrl + 'active';
                window.open(url, "_blank");
             }else{
                 console.log("没想到吧！嘻嘻,出bug了！");
             }
            return false;
    }
  },

  watch: {
    flag(newName, oldName) {
        this.getLists();
    },

  tab(newIndex,oldIndex){
       if (newIndex!=oldIndex) {
           this.index = newIndex;
        }
  }



  },
};
</script>

<style lang="scss" scoped>
    .headTitle {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      background: white;
      align-items: center;
      height: 61px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 21px;
      button {
        width: 84px;
        height: 30px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        background: white;
        color: #666666;
        font-size: 13px;
      }
    }
</style>
